const STORAGE_KEY = 'marketing_attribution';

function getParam(params: URLSearchParams, name: string): string | null {
  return params.get(name) || null;
}

function deriveDeviceType(width: number): string {
  if (width < 768) return 'mobile';
  if (width <= 1024) return 'tablet';
  return 'desktop';
}

/**
 * Captures first-touch marketing attribution and device data.
 * Only writes to localStorage if no data exists yet (preserves first touch).
 * Should be called once on app mount.
 */
export function captureMarketingData(): void {
  if (typeof window === 'undefined') return;

  // Preserve first-touch data — don't overwrite
  if (localStorage.getItem(STORAGE_KEY)) return;

  const params = new URLSearchParams(window.location.search);

  const data = {
    attribution: {
      landing_url: window.location.href,
      landing_page: window.location.pathname,
      referrer: document.referrer || '',
      utm_source: getParam(params, 'utm_source'),
      utm_medium: getParam(params, 'utm_medium'),
      utm_campaign: getParam(params, 'utm_campaign'),
      utm_term: getParam(params, 'utm_term'),
      utm_content: getParam(params, 'utm_content'),
      gclid: getParam(params, 'gclid'),
      fbclid: getParam(params, 'fbclid'),
    },
    device: {
      user_agent: navigator.userAgent,
      browser_language: navigator.language,
      screen_resolution: `${screen.width}x${screen.height}`,
      device_type: deriveDeviceType(window.innerWidth),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
